import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TrendingUp } from "lucide-react";

export default function AdminOps() {
  const [ops, setOps] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/ops");
        setOps(data);
      } catch (e) { /* ignore */ }
    })();
  }, []);

  if (!ops) return <div className="text-light-ink animate-pulse">Loading...</div>;

  const Kpi = ({ label, value, hint, testid }) => (
    <div className="tablo-card p-5" data-testid={testid}>
      <p className="text-xs uppercase tracking-wider text-light-ink">{label}</p>
      <p className="font-serif text-3xl mt-1">{value}</p>
      {hint && <p className="text-xs text-amber flex items-center gap-1 mt-1"><TrendingUp className="w-3 h-3" strokeWidth={1.6}/>{hint}</p>}
    </div>
  );

  return (
    <div className="space-y-6 animate-fade-up">
      <header>
        <p className="text-amber text-xs uppercase tracking-[0.18em] font-medium mb-2">Ops dashboard</p>
        <h1 className="font-serif text-4xl">Tablo at a glance</h1>
        <p className="text-light-ink text-sm mt-2">Live across the Hyderabad pilot.</p>
      </header>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Kpi label="GMV (confirmed)" value={`₹${(ops.total_gmv_inr || 0).toLocaleString("en-IN")}`} hint={`${ops.take_rate_bps / 100}% take = ₹${(ops.estimated_take_inr || 0).toLocaleString("en-IN")}`} testid="kpi-gmv" />
        <Kpi label="Confirmed" value={ops.confirmed_bookings} testid="kpi-confirmed" />
        <Kpi label="Total bookings" value={ops.total_bookings} testid="kpi-total" />
        <Kpi label="Cancelled / no-show" value={`${ops.cancelled + ops.no_show}`} testid="kpi-cancelled" />
      </div>

      <div className="tablo-card p-6">
        <h2 className="font-serif text-2xl mb-4">Top restaurants this period</h2>
        {ops.top_restaurants.length === 0 ? (
          <p className="text-light-ink text-sm">No confirmed bookings yet.</p>
        ) : (
          <ul className="space-y-3">
            {ops.top_restaurants.map((r, idx) => (
              <li key={idx} className="flex items-center justify-between text-sm" data-testid={`top-rest-${idx}`}>
                <div className="flex items-center gap-3">
                  <span className="font-serif text-xl text-amber">{idx + 1}</span>
                  <div>
                    <p className="font-medium">{r.name}</p>
                    <p className="text-xs text-light-ink">{r.area}</p>
                  </div>
                </div>
                <span className="font-medium">{r.count} bookings</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
